module.exports = __webpack_public_path__ + "static/media/factory.6080011f.svg";